// @ts-nocheck

import React, { useContext, useMemo } from 'react';
import { Group, Image, Rect } from 'react-konva';

import Formatter from '../../../i18n/formatter';
import { __, getCurrency } from '../../../i18n/l10n';
import BetshareContext from '../contexts/BetshareContext';
import { getRelativeValue } from '../utils';

import LabelledBloc from './LabelledBloc';
import WinningsArea from './WinningsArea';

const MainArea = (props) => {
  const {
    x,
    y,
    sentence,
    betAmount,
    globalOdds,
    winnings,
    isCancelled,
    isLost,
    forwardRef,
    hasBonus,
    isSystem,
    freebet = false,
  } = props;
  const currency = getCurrency();
  const {
    images: { mainIllustration, topLayer, pictoStake, pictoOdd, pictoFreebets },
    stageWidth,
    userPrefs: { showWinningsAndStake },
  } = useContext(BetshareContext);

  const winningsAndStakePicto = useMemo(
    () => (freebet ? pictoFreebets : pictoStake),
    [freebet, pictoFreebets, pictoStake],
  );

  return (
    <Group x={x} y={y} ref={forwardRef}>
      <Image image={mainIllustration} x={0} y={-y} width={stageWidth} height={getRelativeValue(411, stageWidth)} />
      {!isSystem && (
        <LabelledBloc
          x={getRelativeValue(10, stageWidth)}
          y={getRelativeValue(showWinningsAndStake ? 87 : 30, stageWidth)}
          amount={Formatter.formatOdd(globalOdds)}
          picto={pictoOdd}
          caption={__('Odds')}
        />
      )}
      {showWinningsAndStake && (
        <LabelledBloc
          x={getRelativeValue(10, stageWidth)}
          y={getRelativeValue(30, stageWidth)}
          amount={Formatter.formatNumber(betAmount, currency, false, 2, false, true)}
          picto={winningsAndStakePicto}
          caption={__('Wager')}
        />
      )}
      <WinningsArea
        x={getRelativeValue(0, stageWidth)}
        y={getRelativeValue(411 - y, stageWidth)}
        amount={winnings}
        isLost={isLost}
        isCancelled={isCancelled}
        text={sentence}
      />
      {topLayer && (
        <Image image={topLayer} x={0} y={-y} width={stageWidth} height={getRelativeValue(411, stageWidth)} />
      )}
      {((showWinningsAndStake && hasBonus) || isSystem) && (
        <Rect
          x={getRelativeValue(0, stageWidth)}
          y={getRelativeValue(476 - y, stageWidth)}
          width={stageWidth}
          height={getRelativeValue(5, stageWidth)}
        />
      )}
    </Group>
  );
};

export default MainArea;
